import { CSSProperties } from 'react';

interface IJitsiShowHideContainerStyleProps {
    addOnIsVisible: boolean;
    startingPosition: { bottom: number; left: number };
    translateToHideOrShow: () => { x: number; y: number };
}

const baseContainerStyle: CSSProperties = {
    width: '100%',
    height: '100%',
    minHeight: '100%'
};

const visibleContainerStyle = ({ startingPosition, translateToHideOrShow }: IJitsiShowHideContainerStyleProps): CSSProperties => ({
    width: 380,
    height: 240,
    position: 'absolute',
    zIndex: 3000,
    ...startingPosition,
    verticalAlign: 'top',
    transition: 'all 0.5s ease-in-out',
    transform: `translate(${translateToHideOrShow().x}px, ${translateToHideOrShow().y}px)`,
    display: 'flex',
    justifyContent: 'space-between'
});

export const jitsiShowHideContainerStyle = (props: IJitsiShowHideContainerStyleProps): CSSProperties =>
    props.addOnIsVisible ? visibleContainerStyle(props) : baseContainerStyle;

const visibleInnerContainerStyle: CSSProperties = {
    width: 380,
    height: 240,
    position: 'absolute',
    zIndex: 3000,
    bottom: 0,
    left: 0,
    verticalAlign: 'top',
    display: 'flex',
    justifyContent: 'space-between'
};

export const jitsiShowHideInnerContainerStyle = (props: Pick<IJitsiShowHideContainerStyleProps, 'addOnIsVisible'>): CSSProperties =>
    props.addOnIsVisible ? visibleInnerContainerStyle : baseContainerStyle;

export const hideButtonContainerStyle = (jitsiShowHideInnerContainerOpacity: number): CSSProperties => ({
    backgroundColor: '#2a88d8',
    border: '4px grow #2a88d8',
    borderRadius: '0px 4px 4px 0px',
    width: 19,
    height: 80,
    position: 'absolute',
    zIndex: 3000,
    top: 0,
    right: 0,
    verticalAlign: 'middle',
    cursor: 'pointer',
    opacity: jitsiShowHideInnerContainerOpacity
});
